import { FaArrowRight } from 'react-icons/fa6'
import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import useFetch from '../utils/useFetch'

const Card = ({ card }) => {
  return (
    <div
      className={`flex flex-col flex-1 max-w-[18rem] gap-4 p-4 py-6 bg-white rounded-lg shadow border border-gray-200`}
    >
      <div className={`flex flex-col gap-3 items-center`}>
        <img
          src={card?.icon}
          className='w-10 h-10 rounded-full bg-gray-200'
          alt=''
        />

        <h2 className='text-slate-900 text-2xl text-center font-bold leading-loose'>
          {card?.title}
        </h2>
        <p className='text-sky-950 text-opacity-70 text-base font-normal leading-normal'>
          {card?.description}
        </p>
        {card.link && (
          <div className='w-12 h-12 flex items-center justify-center'>
            <a href={card.link} target='_blank' rel='noreferrer'>
              <button className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'>
                <FaArrowRight size={20} color='white' />
              </button>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

const Odl = () => {
  const data = useFetch('odl')
  const odl = data?.properties
  console.log(odl)
  const title = odl?.title
  const bg = odl?.backgroundImage
    ? retrunAssets(odl?.backgroundImage[0]?.url)
    : returnNotImage()

  const cardWithIcons = odl?.buttonWithIcon?.items?.map(item => {
    item = item?.content?.properties
    return {
      title: item?.title,
      description: item?.description,
      icon: item?.icon ? retrunAssets(item?.icon[0]?.url) : returnNotImage(),
      link: item?.url ? item?.url[0].url : null
    }
  })

  const quickLinks = odl?.quickLinkButton?.items?.map(item => {
    item = item?.content?.properties
    return {
      title: item?.title,
      link: item?.url ? item?.url[0].url : null
    }
  })

  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='flex justify-center flex-col gap-10 w-full p-8 md:p-12 '>
        <div className='flex flex-col gap-3'>
          <h1 className='whitespace-pre-line heading'>
            {DecodeHtml({ html: odl?.mainRichText?.markup })}
          </h1>
        </div>
        <div className='flex flex-wrap justify-center gap-8 mt-4 '>
          {cardWithIcons?.map((card, index) => (
            <Card key={index} card={card} />
          ))}
        </div>
        <div className='w-full flex items-center flex-col justify-center gap-8 heading'>
          <h1 className='whitespace-pre-line '>
            {DecodeHtml({ html: odl?.quickLinkRichText?.markup })}
          </h1>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 w-full max-w-3xl gap-4'>
            {quickLinks &&
              quickLinks?.map((link, index) => (
                <a
                  key={index}
                  href={link.link}
                  target='_blank'
                  rel='noreferrer'
                  className='flex flex-col w-full max-w-[28rem] h-[10rem] justify-center items-center text-slate-900 text-2xl text-center font-bold leading-loose gap-4 p-4 py-6 bg-white rounded-lg shadow border border-gray-200'
                >
                  {link.title}
                </a>
              ))}
          </div>
        </div>
      </div>
    </AnimatedPage>
  )
}

export default Odl
